import React from "react";
import { Outlet } from "react-router-dom";
import { Shell } from "../../components/Shell";

const NAV = [
  { key: "dashboard", to: "/org", label: "Dashboard" },
  { key: "scanner", to: "/org/scanner", label: "Scanner" },
  { key: "events", to: "/org/events", label: "Events" },
  { key: "members", to: "/org/members", label: "Members" },
  { key: "attendance", to: "/org/attendance", label: "Logs" },
  { key: "reports", to: "/org/reports", label: "Reports" },
];

export default function OrgLayout() {
  return (
    <Shell nav={NAV}>
      <Outlet />
    </Shell>
  );
}
